export default __webpack_public_path__ + "static/media/siebe-chugelrundi-saeu.a79153d9.pdf";